module.exports = __webpack_public_path__ + "img/sal_yes.1c4c8802.png";